import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const attributes = Object.freeze({
  color:"",
  classes:"",
  size: "24"
});

export default function View({ attributes={
  color: "",
  classes: "",
  size: ""
}, clickHandler }) {
  const navigate = useNavigate();
  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        xmlns="http://www.w3.org/2000/svg" 
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 38 38"
      >
        <g
          id="Group_16165"
          data-name="Group 16165"
          transform="translate(-1170 -261)"
        >
          <circle
            id="Ellipse_134"
            data-name="Ellipse 134"
            cx="19"
            cy="19"
            r="19"
            transform="translate(1170 261)"
            fill={attributes.color}
          />
          <path
            id="visibility_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
            d="M49.387-789.76a3.7,3.7,0,0,0,2.72-1.12,3.7,3.7,0,0,0,1.12-2.72,3.7,3.7,0,0,0-1.12-2.72,3.7,3.7,0,0,0-2.72-1.12,3.7,3.7,0,0,0-2.72,1.12,3.7,3.7,0,0,0-1.12,2.72,3.7,3.7,0,0,0,1.12,2.72A3.7,3.7,0,0,0,49.387-789.76Zm0-1.536a2.222,2.222,0,0,1-1.632-.672,2.222,2.222,0,0,1-.672-1.632,2.222,2.222,0,0,1,.672-1.632,2.222,2.222,0,0,1,1.632-.672,2.222,2.222,0,0,1,1.632.672,2.222,2.222,0,0,1,.672,1.632,2.222,2.222,0,0,1-.672,1.632A2.222,2.222,0,0,1,49.387-791.3Zm0,4.1a9.879,9.879,0,0,1-5.675-1.739A9.884,9.884,0,0,1,40-793.6a9.884,9.884,0,0,1,3.712-4.661A9.879,9.879,0,0,1,49.387-800a9.879,9.879,0,0,1,5.675,1.739,9.884,9.884,0,0,1,3.712,4.661,9.884,9.884,0,0,1-3.712,4.661A9.879,9.879,0,0,1,49.387-787.2ZM49.387-793.6Zm0,4.693a8.145,8.145,0,0,0,4.427-1.269A8.339,8.339,0,0,0,56.9-793.6a8.339,8.339,0,0,0-3.083-3.424,8.145,8.145,0,0,0-4.427-1.269,8.145,8.145,0,0,0-4.427,1.269,8.339,8.339,0,0,0-3.083,3.424,8.339,8.339,0,0,0,3.083,3.424A8.145,8.145,0,0,0,49.387-788.907Z"
            transform="translate(1140 1074)"
            fill="#fff"
          />
        </g>
      </svg>
    </div>
  );
}
